import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=6adc1c0d&scoped=true"
import script from "./Commands.vue?vue&type=script&lang=js"
export * from "./Commands.vue?vue&type=script&lang=js"
import style0 from "./Commands.vue?vue&type=style&index=0&id=6adc1c0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc1c0d",
  null
  
)

export default component.exports